import { Controller } from '@hotwired/stimulus'
import PreactRailsUJS from 'preact_ujs'

export default class extends Controller {
  initialize () {
    PreactRailsUJS.mountComponents(this.element)
  }

  connect () {
    // Initialise a Zoid frame if we are in an iframe
    if (window.self !== window.top) {
      this.initFrame()
    }
  }

  initFrame () {
    const url = new URL(document.location)
    const modalSize = url.searchParams.get('modal')
    if (modalSize !== 'true') {
      console.debug('mount-js initializing frame', modalSize, document.location.href)
      window.provenance.frameFactory.getFrame(modalSize, document.location.href)
    }
  }
}
